import { createPath } from "@/service/routing/routing";
import { SuperLink as Link } from "@/components/common/super-link";
import { cn } from "@/lib/utils";
import { MedStatusBadge } from "@/components/meds/med-status-badge";
import { Badge } from "@/components/ui/badge";

export function SimpleMedGroupCard({
  medGroup,
  onNavigate,
}: {
  medGroup: MedGroupPreviewVM;
  onNavigate?: () => void;
}) {
  const { title, id, slug, featured, superGroup, inns } = medGroup;
  const groupLink = createPath("meds.group.show", {
    slug,
    id,
  });

  const displayTitle = superGroup?.title ?? title;

  return (
    <div
      className={cn(
        "border border-t-0 bg-white px-4 py-3 first:rounded-t-md first:border-t last:rounded-b-md",
      )}
    >
      <div className="flex flex-wrap items-center gap-2 xl:flex-nowrap">
        <MedStatusBadge status={medGroup.status} />
        <Link
          href={groupLink}
          className="text-remedium-blue-hover font-semibold text-black"
          onClick={onNavigate}
        >
          {displayTitle}
        </Link>
        {featured && (
          <span className="text-remedium-blue text-xs font-medium">
            &nbsp; REKLAMA
          </span>
        )}

        {inns?.length > 0 && (
          <div className="ml-auto flex flex-wrap items-center gap-2">
            <span className="text-xs font-normal text-black">Zawiera:</span>
            {inns.map(({ slug: innSlug, id: innId, name }) => (
              <Badge key={`${innId}-${name}`} variant={"brandSoft"} asChild>
                <Link
                  href={createPath("meds.inn.show", {
                    slug: innSlug,
                    id: innId,
                  })}
                >
                  {name}
                </Link>
              </Badge>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
